import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import StaticColumnTable from "../../../../Components/Common/StaticColumnTable";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI405_2 = ({ hide }) => {
   const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
 const inputData = [
    {
      fieldName: "manWomenSalaryRatio",
      title:
        "What is the ratio of basic salary and remuneration between women and men within each employee category, categorized by significant locations of operation?",
      type: "array",
      letter: "a.",
      fields: [
        {
          fieldName: "employeeCategory",
          title: "Employee Category",
          type: "text",
          placeholder: "Enter Text",
          width: "45%",
        },
        {
          fieldName: "ratio",
          title: "Male to female remuneration ratio",
          type: "ratio",
          width: "45%",
          placeholder: "Enter Ratio",
        },
      ],
    },
  ];

  const questionData = [
    {
      fieldName: "significantLocationsOfOperation",
      title:
        "How does the organization define 'significant locations of operation' for reporting purposes?",
      type: "text",
      placeholder: "Enter Text",
      letter: "b.",
    },
  ];

  const defaultSegments = [
    "Permanent employees",
    "Temporary employees",
    "Permanent workers",
    "Temporary workers",
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI400`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 = res?.data?.data?.GRI400?.ratioBasicSalary;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      significantLocationsOfOperation:
        data?.significantLocationsOfOperation || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
        newErrors[el.fieldName] = "Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // let v1 = validateForm();
      // let v2 = validateTable(inputData, tables, setTabErros);

      // if (!v1 || !v2) return;

      let transformedData2 = {
        ratioBasicSalary: { ...restructureData(tables), ...formData },
        type: "GRI400",
        submitted405_2: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri400/406-1/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/406-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && (
        <p className={styles.section_heading}>
          405 : Diversity and Equal Opportunity
        </p>
      )}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1rem" : "1.5rem" }}>
        405-2 : Ratio of basic salary and remuneration of women to men
      </p>
      {/* a */}
      <StaticColumnTable
        {...{
          inputData,
          tables,
          setTables,
          disabled: disabled,
          errors: tabErrors,
          setErrors: setTabErros,
          data: data,
          defaultSegments,
          parameter: "employeeCategory",
        }}
      />
      {questionData.map((el) => (
        <Box sx={{ mt: 2 }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <p className={styles.ques_heading}>{el.letter}</p>
            <p className={styles.ques_heading}>{el.title}</p>
          </Box>
          <Box sx={{ ml: 3 }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              errors={errors[el.fieldName] && true}
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI405_2;
